export const environment = {
     production: false,
     environment: 'DEV',
     server: 'UI_SERVER_DEV_AZURE',
     gatewayURL: 'https://api.dev1.gva.semgenome.com/gateway/',
     userManagement: 'https://api.dev1.gva.semgenome.com/gateway/usermanagement/',
     console: 'https://api.dev1.gva.semgenome.com/gateway/subscription-console/',
     dashboard: 'https://api.dev1.gva.semgenome.com/gateway/org-dashboard/',
     key: 'IW84Zmx2a21wKW1hdWw2MzlrMSMxcGZk',
     baseURL: 'dev1.gva.semgenome.com'
};
